<template>
  <div>
    <wc-data-box
      :title='storePath.title'
      :titleIcon='storePath.icon'
      :titleIconColor='storePath.iconColor'
      showEdit
      @edit='openEdit'
    >
      <v-simple-table dense>
        <tbody>
          <tr>
            <td :class='label'>Name</td>
            <td :class='dataValue'>{{ item.name }}</td>
          </tr>
          <tr>
            <td :class='label'>Description</td>
            <td :class='dataValue'>{{ item.description }}</td>
          </tr>
          <tr>
            <td :class='label'>Location</td>
            <td :class='dataValue'>{{ item.location }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </wc-data-box>
  <!-- edit dialog box below  -->
    <wc-dialog
      :showDialog='showDialog'
      title='Edit Basics'
      :icon='storePath.icon'
      :iconColor='storePath.iconColor'
      width='400'
      @cancel='cancelEdit'
      @save='saveEdit'
      :loading='isLoading'
    >
      <v-form ref='form'>
        <v-text-field
          label='Name'
          :rules='[rules.required]'
          v-model='itemCopy.name'
        ></v-text-field>
        <v-row>
          <v-col cols='12'>
            <v-text-field
              label='Description'
              v-model='itemCopy.description'
            ></v-text-field>
          </v-col>
          <v-col cols='12'>
            <v-text-field
              label='Location'
              v-model='itemCopy.location'
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'
export default {
  name: 'equipment-basics',
  props: {
    item: {
      required: true
    }
  },
  mixins: [formRules],
  data: () => ({
    label: 'grey--text',
    dataValue: 'text-right',
    showDialog: false,
    isLoading: false,
    itemCopy: {}
  }),
  computed:{
    storePath () { return this.$store.state.icons.dataBox.basics }
  },
  methods: {
    openEdit () {
      this.itemCopy = _.cloneDeep(this.item)
      this.showDialog = true
    },
    cancelEdit () {
      this.showDialog = false
    },
    saveEdit () {
      this.isLoading = true
      this.$emit('update', this.itemCopy)
      this.cancelEdit()
      this.isLoading = false
    }
  }
}
</script>